var windowLoaded = false;
$(window).on('load', function() {
  windowLoaded = true;
});
    
if ( window.location.hash ) scroll(0,0); //on load scroll fix    
if ( window.location.hash ) setTimeout( function() { scroll(0,0); }, 1); // same but some browsers are dumb

import Cookies from 'js-cookie'
import 'slick-carousel/slick/slick.min.js';
import 'scrollmagic/scrollmagic/minified/ScrollMagic.min.js';
import ScrollMagic from 'scrollmagic'

export default {
  init() {
    // JavaScript to be fired on all pages

    //vars
    var header = $('header#header');
    var delay_default = 300;

    
    //smooth scroll to
    function smoothScrollTo(target) {
      $('body, html').stop().animate({
        'scrollTop': target.offset().top - header.outerHeight(),
      }, delay_default*3, 'swing', function() {     //temp hack to fix recursive scroll from shrunk header
        $('body, html').stop().animate({
          'scrollTop': target.offset().top - header.outerHeight(),
        }, 300, 'swing');
      });
      //turnOffMobileMenu();
    }

    $('#mobile-toggle').on('click', function(e) {
      e.preventDefault();
      $('header#header').toggleClass('mobile-toggle');
      $('html').toggleClass('disable-scroll');
    });

    //scrollable link trigger
    function redirectToHomePageForScrolling(target) {
        window.location.href = '/' + target;
    }

    $('.scrollable-link').on('click', function(e) {
      e.preventDefault();
      var scroll_to = $(this).find('a').attr('href');     
      
      if($(scroll_to).length)
        smoothScrollTo($(scroll_to));
      else
        redirectToHomePageForScrolling(scroll_to);
    });

    $('.scroll-to-link').on('click', function(e) {
      e.preventDefault();
      
      var target = $(this).data('target');

      $('html,body').animate({ scrollTop: $(target).offset().top - 10 }, 800);
    });

    //video modal  
    if($('#videoModal').length > 0) {
      var video_src = $('#video').attr('rlsrc');
      $('#videoModal').on('shown.bs.modal', function () {
        Cookies.set('modal-video', 1, { expires: 1 });
        $('#video').attr('src', video_src + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0'); //show video + autoplay
      })

      $('#videoModal').on('hide.bs.modal', function () {
        $('#video').attr('src', video_src); //faux stop video
      }) 

      if(!Cookies.get('modal-video')) {
        $(window).on('load', function() {
          console.log('window loaded');
          setTimeout(
            function(){
              $('#videoModal').modal('show');
            }, 3000);
        });
      }
    }

    //Share Modals
    $('.share-page').on('click', function(e) {
      e.preventDefault();
      $('#shareModal').modal('show');
    });

    //Form
    $('.form-popup').on('click', function(e) {
      e.preventDefault();
      $('#formModal').modal('show');
    });

    $('.share-graphic').on('click', function(e) {
      e.preventDefault();
      var url = $(this).data('url');
      $('#shareGraphic').modal('show');
      $('.st-custom-button-graphic').attr('data-url',url);
      $('.st-custom-button-graphic').attr('data-image',url);
    });

    
    //onScroll
    function navbarScroll() {
      var y = window.scrollY;
      var y2 = 0;
      if(header.length) y2 = 300;
        if (y > y2)
          header.addClass('shrink');
        else if (y == 0)
          header.removeClass('shrink');
    }

    navbarScroll();
     
    $(document).scroll(function() {
      var isStatic =  header.hasClass('static');
      if(!isStatic)
        navbarScroll();
    });

    //Landing
    $('.graphics-slider').slick({
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 3.1,
      slidesToScroll: 1,
      dots:false,
      prevArrow: $('.graphics-slider-slick-prev'),
      nextArrow: $('.graphics-slider-slick-next'),
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
          true: false,
          infinite:false,
          dots: false,
        },
      }],
    });

    $('.experts-slider').slick({
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots:false,
      prevArrow: $('.experts-slider-slick-prev'),
      nextArrow: $('.experts-slider-slick-next'),
    });


    $('.experts-slider-b').slick({
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots:true,
      prevArrow: $('.experts-slider-slick-prev'),
      nextArrow: $('.experts-slider-slick-next'),
    });

    $('.graphics-le-slider').slick({
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 4.1,
      slidesToScroll: 1,
      dots:false,
      prevArrow: $('.graphics-slider-slick-prev'),
      nextArrow: $('.graphics-slider-slick-next'),
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
          true: false,
          infinite:false,
          dots: false,
        },
      }],
    });

    $(function () { // wait for document ready
      // init controller
      var controller = new ScrollMagic.Controller();

      new ScrollMagic.Scene({triggerElement: '#area1-trigger'})
        .setClassToggle('#marching-map2', 'visible')
        .addIndicators() // add indicators (requires plugin)
        .addTo(controller);
  
      new ScrollMagic.Scene({triggerElement: '#area1-trigger'})
        .setClassToggle('#marching-map1', 'hidden')
        .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

     
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //vars
    var header = $('header');
    var delay_default = 300;

    //smooth scroll to
    function smoothScrollTo(target) {
      $('body, html').stop().animate({
        'scrollTop': target.offset().top - header.outerHeight(),
      }, delay_default*3, 'swing', function() {     //temp hack to fix recursive scroll from shrunk header
        $('body, html').stop().animate({
          'scrollTop': target.offset().top - header.outerHeight(),
        }, 300, 'swing');
      });
    }

    //afterLoad
    function afterLoad() {
      console.log('Window Loaded');

      if(window.location.hash && $(window.location.hash).length)
        smoothScrollTo($(window.location.hash));
    }

    //onLoad triger if not
    if(!windowLoaded)
        $(window).on('load', afterLoad);
    else
        afterLoad();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js